export default __webpack_public_path__ + "static/media/default.077128c9.avif";